// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-uHcK","colMin":"styles_colMin__1y70a"};